import React, { Component } from 'react';
import { Button, Input, Form, Table, Row, Col, Modal, message } from 'antd';
import send from '../../util/request';
import { formItemLayout } from '../../util/formItemLayoutConfig';
import './plabReportModal.less';
class CpProductChoose extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productList: [], // 选品列表
      addList: [], // 批量勾选的数据
      selectedRowKeys: [], // 勾选完清空数据
      loading: true,
      isBatchAdd: false, // 选品中的批量添加
      currentPage: 1, // 获取选品列表分页
      pageSize: 10, // 获取选品列表分页
      total: 0, // 获取选品列表分页
      chooseProductObj: {},  // 记录当前添加的商品
    };
  }
  columns = [
    {
      title: '商品名称',
      dataIndex: 'sale_name',
      key: 'sale_name',
      align: 'center',
      width: 180
    },
    {
      title: '商品编码',
      dataIndex: 'sku_no',
      key: 'sku_no',
      align: 'center',
      width: 120
    },
    {
      title: '等级',
      dataIndex: 'level',
      key: 'level',
      align: 'center',
    },
    {
      title: '产地',
      dataIndex: 'place',
      key: 'place',
      align: 'center',
    },
    {
      title: '单位',
      dataIndex: 'unit',
      key: 'unit',
      align: 'center',
    },
    {
      title: '规格',
      dataIndex: 'spec',
      key: 'spec',
      align: 'center',
      width: 120
    },
    {
      title: '单位重量(KG)',
      dataIndex: 'weight',
      key: 'weight',
      align: 'center',
      width: 120
    },
    {
      title: '操作',
      align: 'center',
      fixed: 'right',
      width: 80,
      render: (text, record) => (
        <a style={{ color: '#D60505' }} onClick={() => this.chooseAdd(record, 1)}>添加</a>
      ),
    },
  ];
  componentDidMount() {
    this.getProductList();
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  handleQuery = (values) => {
    const { productName = '' } = values;

    this.setState({
      productName: productName.trim(),
      currentPage: 1,
      pageSize: 10,
    });
    this.getProductList();
  };
  // 获取选品列表
  getProductList = () => {
    this.setState({
      loading: true
    });
    const {
      currentPage,
      pageSize,
      productName,
    } = this.state;
    send({
      url: '/ipp/order-plan-task/select-goods',
      method: 'GET',
      params: {
        sale_name: productName,
        order_no: this.props.taskNo,
        page: currentPage,
        limit: pageSize,
      },
    }).then((res) => {
      if (res.data && res.data.code === 0) {
        const { total, data = [] } = res.data.data;
        this.setState({
          loading: false,
          productList: data,
          total
        });
      }
    });
  };
  // 选品添加、批量添加
  chooseAdd = (obj, type) => {
    let array = [];
    if (type === 1) {
      array.push(obj);
    } else {
      array = this.state.addList;
    }

    let currentObj = {};
    array.forEach(item => {
      currentObj[item.good_id] = item;
    });

    let { chooseProductObj } = this.state;
    chooseProductObj = Object.assign({}, chooseProductObj, currentObj);

    this.setState({
      chooseProductObj,
      isBatchAdd: false,
      addList: [],
      selectedRowKeys: []
    },()=>{
      this.props.submitModal(chooseProductObj);
    });
    message.success('商品添加成功');
  };
  handleCancel = () => {
    const { hideModal } = this.props;
    hideModal();
  }
  render() {
    const { productList, isBatchAdd, selectedRowKeys, currentPage, pageSize, total } = this.state;
    const { loading } = this.props;
    const chooseCheck = {
      selectedRowKeys,
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({
          isBatchAdd: selectedRowKeys.length > 0 ? true : false,
          addList: selectedRows,
          selectedRowKeys,
        });
      },
    };
    return (
      <Modal
        title='选品'
        open={true}
        width={980}
        maskClosable={false}
        onCancel={this.handleCancel}
        className='plabReportModal'
        cancelText="取消">
        <Form
          {...formItemLayout}
          onFinish={this.handleQuery}>
          <Row>
            <Col span={8}>
              <Form.Item label='商品名称' name="productName">
                <Input maxLength={100} placeholder='请输入商品名称' />
              </Form.Item>
            </Col>
            <Col span={4} offset={2}>
              <Button type='primary' htmlType='submit'>查询</Button>
            </Col>
          </Row>
        </Form>
        <div style={{ textAlign: 'right', margin: '0 20px 10px 0' }}>
          <Button disabled={!isBatchAdd} type='primary' onClick={this.chooseAdd}>批量添加</Button>
        </div>
        <Table
          rowKey={(record) => record.good_id}
          columns={this.columns}
          dataSource={productList}
          loading={loading}
          rowSelection={chooseCheck}
          scroll={{ x: 1000 }}
          pagination={{
            pageSize: pageSize,
            total: total,
            current: currentPage,
            onChange: (currentPage, pageSize) => {
              this.setState(
                {
                  currentPage,
                  pageSize,
                },
                () => {
                  this.getProductList();
                }
              );
            },
          }}
          style={{
            marginTop: '20px',
            minHeight: '500px',
            backgroundColor: '#fff',
          }}
        />
      </Modal>
    );
  }
}

export default CpProductChoose;
